import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Chip,
  Card,
  CardContent,
  CardActionArea,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import Container from "../../base/Container";
import { useSearchParams } from "react-router-dom";
import { Tabs, Tab } from "@mui/material";
import FAQComponent from "./FAQComponent";
import ProvideFeedbackTab from "./ProvideFeedbackTab";
import { rememberSectionPath } from "../../hooks/useSessionState";

const HelpCenter = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTopic = searchParams.get("topic") || "faq";

  // So the sidebar "Help Center" nav link can return to this exact topic.
  useEffect(() => {
    const qs = searchParams.toString();
    rememberSectionPath("helpcenter", qs ? `/helpcenter?${qs}` : "/helpcenter");
  }, [searchParams]);

  const popularSearches = ["Payment", "Invoicing", "Client Graph"];

  const recommendedTopics = [
    // {
    //     icon: '/helpdesk/application.png',
    //     title: 'Request New Feature',
    //     // slug: 'request-feature',
    // },
    // {
    //     icon: '/helpdesk/speech-bubble.png',
    //     title: 'Provide your Suggestion',
    //     // slug: 'provide-suggestion',
    // },
    {
      icon: "/helpdesk/faq.png",
      title: "Provide Feedback",
      slug: "provide-feedback",
      
    },
  ];

  const handleTopicSelect = (topicSlug) => {
    setSearchParams({ topic: topicSlug });
  };

  return (
    <Container>
      {!activeTopic ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 120px)",
          }}
        >
          <Box
            sx={{
              background: "linear-gradient(90deg, #0170B9 0%, #4AAECF 100%)",
              py: 6,
              px: 3,
              textAlign: "center",
              color: "white",
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px",
            }}
          >
            <Box
              sx={{
                maxWidth: "700px",
                mx: "auto",
                width: "100%",
              }}
            >
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontSize: "28px",
                  lineHeight: "22px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                How can we help you?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontStyle: "normal",
                  fontSize: "14px",
                  lineHeight: "22px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Search here to get answers to your questions
              </Typography>

              <Box
                sx={{
                  mb: 2,
                  width: "420px",
                  maxWidth: "100%",
                  mx: "auto",
                }}
              >
                <TextField
                  fullWidth
                  placeholder="Search for topics"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ ml: 1 }}>
                        <SearchIcon
                          sx={{ color: "#666", fontSize: "1.25rem" }}
                        />
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: "white",
                      borderRadius: "32px",
                      border: "1px solid #E0E0E0",
                      paddingTop: "8px",
                      paddingRight: "4px",
                      paddingBottom: "8px",
                      paddingLeft: "4px",
                      gap: "10px",
                      minHeight: "38px",
                      height: "38px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                  }}
                  sx={{
                    width: "420px",
                    maxWidth: "100%",
                    mx: "auto",
                    display: "block",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    mr: 1,
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 400,
                    fontStyle: "normal",
                    fontSize: "12px",
                    lineHeight: "22px",
                    letterSpacing: "0px",
                  }}
                >
                  Popular Search:
                </Typography>
                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                  {popularSearches.map((search, index) => (
                    <Chip
                      key={index}
                      label={search}
                      onClick={() => setSearchQuery(search)}
                      size="small"
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        color: "white",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontStyle: "normal",
                        fontSize: "12px",
                        lineHeight: "22px",
                        letterSpacing: "0px",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.3)",
                        },
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              p: 3,
              width: "100%",
              borderLeft: "1px solid #E0E0E0",
              borderRight: "1px solid #E0E0E0",
              borderBottom: "1px solid #E0E0E0",
              borderRadius: "0 0 24px 24px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontStyle: "bold",
                fontSize: "18px",
                lineHeight: "28px",
                letterSpacing: "0px",
                color: "#333",
                verticalAlign: "bottom",
              }}
            >
              Recommended Topics
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 3,
                color: "#666",
                fontFamily: "Inter, sans-serif",
                fontWeight: 400,
                fontStyle: "normal",
                fontSize: "14px",
                lineHeight: "22px",
                letterSpacing: "0px",
                verticalAlign: "middle",
              }}
            >
              Select the topic you would like to explore
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3, // Controls the space between cards
              }}
            >
              {recommendedTopics.map((topic, index) => (
                <Card
                  key={index}
                  sx={{
                    width: 232, // Fixed width for a squarish shape
                    height: 214, // Fixed height
                    borderRadius: "16px",
                    border: "1px solid #E0E0E0",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                      borderColor: "#1976D2",
                    },
                  }}
                >
                  <CardActionArea
                    sx={{ height: "100%", p: 2 }}
                    onClick={() => handleTopicSelect(topic.slug)}
                    disabled={!topic.slug}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        height: "100%",
                        p: 0,
                        "&:last-child": { pb: 0 },
                      }}
                    >
                      <Box
                        component="img"
                        src={topic.icon}
                        alt={topic.title}
                        sx={{ width: 48, height: 48, mb: 2 }}
                      />
                      <Typography
                        variant="body1" // Using body1 for slightly larger text if needed
                        component="h3"
                        sx={{
                          fontWeight: 600,
                          color: "#333",
                        }}
                      >
                        {topic.title}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </Box>
        </Box>
      ) : (
        // ELSE, IF A TOPIC IS IN THE URL, SHOW THE DETAILS VIEW
        <TopicDetails
          currentTopic={activeTopic}
          onTopicChange={(newTopic) => setSearchParams({ topic: newTopic })}
        />
      )}
    </Container>
  );
};

export default HelpCenter;

const TopicDetails = ({ currentTopic, onTopicChange }) => {
  const handleTabChange = (_event, newTopic) => {
    onTopicChange(newTopic);
  };

  const getTopicContent = (topic) => {
    switch (topic) {
      // case 'request-feature':
      //     return <Typography sx={{ p: 3 }}>Details about requesting a feature...</Typography>;
      // case 'provide-suggestion':
      //     return <Typography sx={{ p: 3 }}>Details about providing a suggestion...</Typography>;
      case "faq":
        return <FAQComponent />;
      case "provide-feedback":
        return <ProvideFeedbackTab />;
      default:
        return null;
    }
  };

  // Define the common styles for the tabs here
  const tabStyles = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "0px",
    verticalAlign: "middle",
    textTransform: "none",
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 120px)",
        width: "100%",
        border: "1px solid #E0E0E0",
        borderRadius: "16px 16px 0 0",
        boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
      }}
    >
      <Box sx={{ flexShrink: 0, borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={currentTopic} onChange={handleTabChange} sx={{ pt: 1 }}>
          <Tab label="FAQ" value="faq" sx={tabStyles} />
          {/* <Tab label="Request New Feature" value="request-feature" sx={tabStyles} />
                    <Tab label="Provide your Suggestion" value="provide-suggestion" sx={tabStyles} /> */}
          <Tab label="Provide Feedback" value="provide-feedback" sx={tabStyles} />
        </Tabs>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
        }}
      >
        {getTopicContent(currentTopic)}
      </Box>
    </Box>
  );
};
